export type RoomId = string
export type PublisherId = number
export type JoinToken = string
export type ParticipantId = string
export type CommaSeparatedList = string

export type Publisher = {
    id: ParticipantId;
}

const __KNOWN_VIDEO_CODECS = ['av1', 'vp8', 'vp9', 'h264'] as const;
export type VideoCodec = typeof __KNOWN_VIDEO_CODECS[number];
export const KNOWN_VIDEO_CODECS = __KNOWN_VIDEO_CODECS.map(v => v);
